// One action that didn't land, in the coach's voice (v2/failures.js): never
// the athlete's fault, with Try again (the same command, sent afresh),
// Dismiss, and the backend's reason under Details for support. SyncStatus
// lists the queue's. No context, so the tests render it. Mirrors the
// mobile app's components/v2/FailureNote.tsx.
import React, { useState } from 'react';
import { ChevronDown, ChevronRight, X } from 'lucide-react';
import { canRetry, failureDetails, failureText } from '../../v2/failures';

/** Figma "Inline note" (Error): a coral frame and dot, the words, Try again; Details › under it. */
export default function FailureNote({ failure, onRetry, onDismiss }) {
  const [open, setOpen] = useState(false);
  const details = failureDetails(failure);
  return (
    <div role="status">
      <div className="flex items-start gap-2.5 rounded-chip border border-status-danger bg-bg-surface px-3.5 py-3">
        <span aria-hidden="true" className="mt-[6px] h-2 w-2 shrink-0 rounded-full bg-status-danger" />
        <span className="flex-1 type-body-small text-text-body">{failureText(failure)}</span>
        {canRetry(failure) && (
          <button type="button" onClick={onRetry} className="shrink-0 type-label text-accent-default hover:text-accent-hover">
            Try again
          </button>
        )}
        <button type="button" aria-label="Dismiss" onClick={onDismiss} className="mt-px shrink-0 text-text-tertiary hover:text-text-primary">
          <X size={14} />
        </button>
      </div>
      {details && (
        <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open}
          className="mt-1.5 flex min-h-[24px] items-center gap-0.5 type-caption text-text-tertiary hover:text-text-body">
          Details {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        </button>
      )}
      {open && details && <p className="m-0 mt-1 break-words font-mono text-[11px] text-text-tertiary">{details}</p>}
    </div>
  );
}
